import { differenceInYears, parseISO } from 'date-fns'

export function calculateAge(dob: Date | string): number {
  if (typeof dob === 'string') dob = parseISO(dob)
  return differenceInYears(new Date(), dob)
}

export function stringBool(bool: boolean): 'true' | 'false' {
  return bool ? 'true' : 'false'
}
